import React from 'react';
import { Spinner } from 'react-bootstrap';
import { usePatientService } from '~/services';
import { useRoleActions } from '~/util/useRoleActions';

interface RemoveProps {
    riskGap: RiskGapType;
    patientId: number;
    handleClose: () => void;
}

export function Remove({ riskGap, patientId, handleClose }: RemoveProps) {
    const { removeRiskGap } = usePatientService();
    const canRemove = useRoleActions('allow_save_edit_answer_risk_gap', null);
    const [confirm, setConfirm] = React.useState(false);
    const [deleting, setDeleting] = React.useState(false);

    async function remove() {
        setDeleting(true);
        await removeRiskGap(riskGap.id, patientId);
        setDeleting(false);
        setConfirm(false);
        handleClose();
    }

    if (!canRemove || !riskGap.is_added || riskGap.status !== 1) return null;

    return (
        <div className="mb-3">
            {!confirm ? (
                <div className="text-center">
                    <button
                        className="btn btn-danger"
                        type="button"
                        onClick={() => setConfirm(true)}
                    >
                        Delete
                    </button>
                </div>
            ) : (
                <div className="text-center">
                    <p>Are you sure? This action cannot be undone.</p>
                    <div>
                        <button
                            className="btn btn-secondary me-4"
                            onClick={() => setConfirm(false)}
                            type="button"
                        >
                            Cancel
                        </button>
                        <button
                            className="btn btn-danger"
                            disabled={deleting}
                            onClick={remove}
                            type="button"
                        >
                            {deleting && (
                                <Spinner
                                    animation="border"
                                    variant="light"
                                    size="sm"
                                    role="status"
                                    className="me-1"
                                />
                            )}
                            Yes, Delete
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
